import React from "react";
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import { StatisticsEmptyState } from "../Statistics/components/statisticsEmptyState";
import { REPORTS_DETAIL_MUTED_DARK } from "./reportsDetailTheme";

export function ReportProcessingState(_props: {
  title?: string | null;
  reportId: string;
}): React.ReactElement {
  return (
    <Flex flex="1" minH={0} w="100%" align="center" justify="center" py={4}>
      <StatisticsEmptyState
        variant="loading"
        fillParent
        title="Generating your report"
        description="Market data and analysis are being prepared. This can take a few minutes. You can leave this page — we'll refresh when the report is ready."
      />
    </Flex>
  );
}

export function ReportFailedState(props: {
  title?: string | null;
  errorMessage?: string | null;
  errorAction?: string | null;
}): React.ReactElement {
  const history = useHistory();
  const subtleText = useColorModeValue("gray.500", REPORTS_DETAIL_MUTED_DARK);

  return (
    <Box w="100%" maxW="640px" mx="auto" mt={8}>
      <Alert status="error" borderRadius="md" flexDirection="column" alignItems="stretch" py={6}>
        <Flex align="flex-start" gap={3} mb={4}>
          <AlertIcon />
          <Box flex="1" textAlign="left">
            <Text fontFamily="'Urbanist', sans-serif" fontWeight="semibold" fontSize="lg" mb={1}>
              Report generation failed
            </Text>
            {props.title ? (
              <Text fontSize="sm" color={subtleText} fontFamily="'IBM Plex Sans', sans-serif" mb={2}>
                {props.title}
              </Text>
            ) : null}
            <Text fontSize="sm" fontFamily="'IBM Plex Sans', sans-serif">
              {props.errorMessage?.trim() ||
                "Something went wrong while building this report. You can start a new generation — it counts toward your daily limit."}
            </Text>
            {props.errorAction?.trim() ? (
              <Text
                fontSize="sm"
                color={subtleText}
                fontFamily="'IBM Plex Sans', sans-serif"
                mt={2}
              >
                {props.errorAction.trim()}
              </Text>
            ) : null}
          </Box>
        </Flex>
        <Button
          alignSelf="flex-start"
          bgGradient="linear-gradient(135deg, #38BBD1, #3EEAEC)"
          color="white"
          onClick={() => history.push("/reports/new")}
        >
          Try again
        </Button>
      </Alert>
    </Box>
  );
}
